// extracted by mini-css-extract-plugin
export var bodySections = "_dl-8";
export var gray = "_dl-7";
export var green = "_dl-4";
export var iconContainer = "_dl-9";
export var iconWidgetContainer = "_dl-1";
export var phoneIcon = "_dl-2";
export var red = "_dl-5";
export var statusDot = "_dl-3";
export var widgetContainer = "_dl-0";
export var yellow = "_dl-6";